'use strict';
const _ = require('underscore');
const Ajax = require('common/infra/ajax');

class API {
    constructor() {
        // TODO: 本来 API は Cursor を保持するべきではない
        // actionwork など同様の API とともにリファクタリングする
        this._cursors = {};
        this._mores = {};
    }

    /**
     * Task の id から Task を取得する
     *
     * @param projectId
     * @param taskId
     * @param option: {noRaise: true} を設定すると、ObjectNotFoundError を無視します
     * @returns {*}
     */
    getByID(projectId, taskId, option) {
        return Ajax.GET(`/api/projects/${projectId}/tasks/${taskId}`, option);
    }

    /**
     * relatedKeys に key が入っている Task を取得する
     *
     * @param projectID
     * @param relatedKey
     * @param limit
     * @param cursor {string}
     * @returns {*}
     */
    getNextByRelatedKey(projectID, relatedKey, limit, cursor) {
        const urlsafeKey = relatedKey.toUrlsafeString();
        const path = `/api/projects/${projectID}/tasks?key=${urlsafeKey}`;
        let params = new URLSearchParams();

        params.append('limit', limit);
        if(cursor) {
            params.append('nextCursor', cursor);
        }

        return Ajax.GET(`${path}&${params.toString()}`);
    }

    /**
     * relatedKeys に key が入っている Task で fetch できていないものがあれば true を返す
     *
     * @param projectID
     * @param relatedKey
     * @returns {*}
     */
    hasNextByRelatedKey(projectID, relatedKey) {
        const urlsafeKey = relatedKey.toUrlsafeString();
        const path = `/api/projects/${projectID}/tasks?key=${urlsafeKey}`;

        return _.has(this._mores, path) && this._mores[path];
    }

    /**
     * Task を作成する
     *
     * @param projectId
     * @param taskJSON
     * @returns {*}
     */
    create(projectId, taskJSON) {
        return Ajax.POST(`/api/projects/${projectId}/tasks`, taskJSON);
    }

    /**
     * Task を更新する
     *
     * @param projectId
     * @param taskId
     * @param taskJSON
     * @returns {*}
     */
    update(projectId, taskId, taskJSON) {
        return Ajax.PUT(`/api/projects/${projectId}/tasks/${taskId}`, taskJSON);
    }

    /**
     * Task を削除する
     *
     * @param projectId
     * @param taskId
     */
    delete(projectId, taskId) {
        return Ajax.DELETE(`/api/projects/${projectId}/tasks/${taskId}`);
    }

    /**
     * Task のコメントに対して返信する
     *
     * @param projectID
     * @param taskID
     * @param commentJSON
     * @returns {*}
     */
    replyComment(projectID, taskID, commentJSON) {
        return Ajax.POST(`/api/projects/${projectID}/tasks/${taskID}/reply-comment`, commentJSON);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./communication/infra/api/task/index.js